// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3fj_Z","header":"MergedInvoice_header__1Nzng"};